<div class="emm-location-sets-form-content" *ngIf="locationSetDetail$ | async as item">
    <form [formGroup]="form">
        <div    class="flex-gap-12-5vw flex-space-between-center flex-row">
            <label class="mt-4">Name</label>
            <mat-form-field class="flex-40" >
                <input matInput
                       formControlName="name"
                       type="text"
                       placeholder="Name"
                >
            </mat-form-field>
        </div>

        <div    class="flex-gap-10vw flex-space-between-center flex-row">
            <label class="mt-4">Description</label>
            <mat-form-field class="flex-40" >
                <textarea matInput
                          cdkTextareaAutosize
                          cdkAutosizeMinRows="3"
                          formControlName="description"
                          type="text"
                          placeholder="Description"
                ></textarea>
            </mat-form-field>
        </div>

        <div    class="flex-gap-9vw flex-space-between-center flex-row">
            <label class="mt-4">Country&nbsp;Code</label>
            <mat-form-field class="flex-40" >
                <mat-select
                    formControlName="countryCode"
                    type="select"
                    placeholder="Select a Country"
                >
                    <mat-option [value]="'US'">
                        {{ countries[0] }}
                    </mat-option>
                    <mat-option [value]="'CA'">
                        {{ countries[1] }}
                    </mat-option>
                    <mat-option [value]="'PR'">
                        {{ countries[2] }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </form>
</div>
